import { render, staticRenderFns } from "./ServiceAddForm.vue?vue&type=template&id=3b05347e&"
import script from "./ServiceAddForm.vue?vue&type=script&lang=js&"
export * from "./ServiceAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports